import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/http-services/user.service';
import { AuthenticationService } from '../../service/http-services/authentication.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    public loginServ: AuthenticationService,
    private userService: UserService
  ) { }

  ngOnInit(): void {}

  isHideOnUrl(): boolean {
    let hideOn = ["/setup", "/login", "/register"];
    if (hideOn.some(s => window.location.href.includes(s))) {
      return true;
    }
    else {
      return false;
    }
  }

  get user(){
    return this.userService.getUserStorage();
  }
  
}
